<app-spinner-overlay></app-spinner-overlay>
<h2 mat-dialog-title>Prompt</h2>
<div mat-dialog-content class="dialog-center-cont">
  <form [formGroup]="promptAI" appFormContainer [larghezza]="1">
    <mat-form-field
      (mousedown)="$event.stopPropagation()"
      appFormElement
      [larghezza]="1"
      [riempi]="true"
    >
      <mat-label>Prompt AI</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        placeholder="Prompt AI"
        formControlName="prompt"
        rows="4"
      ></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
